/**
 * @file contains functions used to create urls to reroute via <Link /> or navigate
 * Can be same with the path routes, but we keep urls to be future-proof
 */

import { SEARCH_PARAM__SIDEBAR } from '../../constants/routing/searchParams';
import { SIDEBAR__PARAM_HOME } from '../../constants/sidebar';
import { Hotel } from '../../generated/graphql';
import { reportError } from '../../services/reporting';

import { getNoMatchUrl } from './404';

/**
 * Get URL for / route
 *
 * @param hotelId ID of the hotel
 * @returns       A string in a url format
 */
export const getDashboardUrl = (hotelId: Hotel['id'] | null): string => {
  if (hotelId === null) {
    reportError('HotelId passed to getDashboardUrl is null');
    return getNoMatchUrl();
  }
  return `/${hotelId}?${SEARCH_PARAM__SIDEBAR}=${SIDEBAR__PARAM_HOME}`;
};
